export enum ROUTE {
    // ---------------- Authentication ----------------
    AUTHENTICATION = "/auth",
    LOGIN = `${ROUTE.AUTHENTICATION}/login`,
    REFRESH = `${ROUTE.AUTHENTICATION}/refresh`,
    LOGOUT = `${ROUTE.AUTHENTICATION}/logout`,

    // ---------------- Profile ----------------
    PROFILE = `/profile`
}
